{
 "id": "dog",
 "class": "pet",
 "size": {
  "w": 40,
  "h": 40
 },
 "anchor": {
  "x": 19,
  "y": 38
 },
 "palette": {
  "k": "#23140b",
  "d": "#472713",
  "E": "#633616",
  "F": "#7d471e",
  "s": "#9b5d27",
  "b": "#be7934",
  "l": "#d89648",
  "h": "#eab263",
  "g": "#b89062",
  "c": "#dcc096",
  "C": "#efe0c2",
  "n": "#18100b",
  "N": "#3b2a20",
  "y": "#1a0f09",
  "w": "#3d2210",
  "e": "#ebe2d5",
  "r": "#a82c2c",
  "R": "#cf4a4a",
  "q": "#731c1c",
  "m": "#e6b832",
  "M": "#f7d969",
  "t": "#d9687e",
  "p": "#ad4459"
 },
 "frames": {
  "sit_0": [
   "........................................",
   "........................................",
   "........................................",
   "................kkkkkkk.................",
   "..............kkhlllbbbkk...............",
   "...........kkkhlllbbbbssskkk............",
   "..........kFldllbsslssbssdFEk...........",
   ".........kFFskleyllbbbeyskFFEk..........",
   ".........kFFEkbywlcbbsywskFEEk..........",
   ".........kFFEkbbCcccggbsskFEEk..........",
   ".........kFEEkbcCCcccggsskEEEk..........",
   ".........kFEEkbCccNnnccgskEEEk..........",
   "..........kEEkbcccnnnccgskEEk...........",
   "...........kk.kccccdccggk.kk............",
   "..............kcgddkddggk...............",
   "..............kRdccgggdqk...............",
   ".............kRRrdddddrqqk..............",
   "............kllbdCCMcddbssk.............",
   "...........kllbCCccmccggbssk............",
   "...........kllbCCcccccggbssk............",
   "...........klbbCCcccccggbssk............",
   "...........klbbbCccccggbsssk............",
   "...........klbbbbccccggbsssk............",
   "..........kbllbbbbcccggbbsssk...........",
   ".........kbbslllbbccgggbssdFsk..........",
   ".........kbbslllbdcgggdbssdFsk..........",
   "........klbbdlllbdggggdbssdsFsk.........",
   "........kbbbdlllbdssEsdbssdsFFk.........",
   "........kbbbdllbdEEEEEdbssdsFFk...kkk...",
   "........kbbsdllbdEEEEEdbssdsFFk..kllbk..",
   "........kbbsdllbddEEEdkbssdsFFk.klbbck..",
   "........kbsskllbkdddddksbsksFFkkbbcckk..",
   "........kbsskllbkkkkkkksbsksFEkbsckk....",
   "........kbsskllbk.....kbssksFEkkkk......",
   "........kbsskllbk.....kbssksFEk.........",
   "........kbdskllck.....kbcsksdEk.........",
   "........kbsklccbk.....kbccsksEk.........",
   "........kkkkcdcdk.....kcdcgkkkk.........",
   "...........kkkkkk.....kkkkkk............",
   "........................................"
  ],
  "sit_1": [
   "........................................",
   "........................................",
   "........................................",
   "................kkkkkkk.................",
   "..............kkhlllbbbkk...............",
   "...........kkkhlllbbbbssskkk............",
   "..........kFldllbsslssbssdFEk...........",
   ".........kFFskleyllbbbeyskFFEk..........",
   ".........kFFEkbywlcbbsywskFEEk..........",
   ".........kFFEkbbCcccggbsskFEEk..........",
   ".........kFEEkbcCCcccggsskEEEk..........",
   ".........kFEEkbCccNnnccgskEEEk..........",
   "..........kEEkbcccnnnccgskEEk...........",
   "...........kk.kccccdccggk.kk............",
   "..............kcgddkddggk...............",
   "..............kRdccgggdqk...............",
   ".............kRRrdddddrqqk..............",
   "............kllbdCCMcddbssk.............",
   "...........kllbCCccmccggbssk............",
   "...........kllbCCcccccggbssk............",
   "...........klbbCCcccccggbssk............",
   "...........klbbbCccccggbsssk............",
   "...........klbbbbccccggbsssk............",
   "..........kbllbbbbcccggbbsssk.....kkk...",
   ".........kbbslllbbccgggbssdFsk...khlbk..",
   ".........kbbslllbdcgggdbssdFsk...klbck..",
   "........klbbdlllbdggggdbssdsFsk.klbcck..",
   "........kbbbdlllbdssEsdbssdsFFk.kbbckk..",
   "........kbbbdllbdEEEEEdbssdsFFkkbsck....",
   "........kbbsdllbdEEEEEdbssdsFFksskk.....",
   "........kbbsdllbddEEEdkbssdsFFkkk.......",
   "........kbsskllbkdddddksbsksFFk.........",
   "........kbsskllbkkkkkkksbsksFEk.........",
   "........kbsskllbk.....kbssksFEk.........",
   "........kbsskllbk.....kbssksFEk.........",
   "........kbdskllck.....kbcsksdEk.........",
   "........kbsklccbk.....kbccsksEk.........",
   "........kkkkcdcdk.....kcdcgkkkk.........",
   "...........kkkkkk.....kkkkkk............",
   "........................................"
  ],
  "sit_blink_0": [
   "........................................",
   "........................................",
   "........................................",
   "................kkkkkkk.................",
   "..............kkhlllbbbkk...............",
   "...........kkkhlllbbbbssskkk............",
   "..........kFldllbsslssbssdFEk...........",
   ".........kFFsklsbllbbbsbskFFEk..........",
   ".........kFFEkbkklcbbskkskFEEk..........",
   ".........kFFEkbbCcccggbsskFEEk..........",
   ".........kFEEkbcCCcccggsskEEEk..........",
   ".........kFEEkbCccNnnccgskEEEk..........",
   "..........kEEkbcccnnnccgskEEk...........",
   "...........kk.kccccdccggk.kk............",
   "..............kcgddkddggk...............",
   "..............kRdccgggdqk...............",
   ".............kRRrdddddrqqk..............",
   "............kllbdCCMcddbssk.............",
   "...........kllbCCccmccggbssk............",
   "...........kllbCCcccccggbssk............",
   "...........klbbCCcccccggbssk............",
   "...........klbbbCccccggbsssk............",
   "...........klbbbbccccggbsssk............",
   "..........kbllbbbbcccggbbsssk...........",
   ".........kbbslllbbccgggbssdFsk..........",
   ".........kbbslllbdcgggdbssdFsk..........",
   "........klbbdlllbdggggdbssdsFsk.........",
   "........kbbbdlllbdssEsdbssdsFFk.........",
   "........kbbbdllbdEEEEEdbssdsFFk...kkk...",
   "........kbbsdllbdEEEEEdbssdsFFk..kllbk..",
   "........kbbsdllbddEEEdkbssdsFFk.klbbck..",
   "........kbsskllbkdddddksbsksFFkkbbcckk..",
   "........kbsskllbkkkkkkksbsksFEkbsckk....",
   "........kbsskllbk.....kbssksFEkkkk......",
   "........kbsskllbk.....kbssksFEk.........",
   "........kbdskllck.....kbcsksdEk.........",
   "........kbsklccbk.....kbccsksEk.........",
   "........kkkkcdcdk.....kcdcgkkkk.........",
   "...........kkkkkk.....kkkkkk............",
   "........................................"
  ],
  "sit_blink_1": [
   "........................................",
   "........................................",
   "........................................",
   "................kkkkkkk.................",
   "..............kkhlllbbbkk...............",
   "...........kkkhlllbbbbssskkk............",
   "..........kFldllbsslssbssdFEk...........",
   ".........kFFsklsbllbbbsbskFFEk..........",
   ".........kFFEkbkklcbbskkskFEEk..........",
   ".........kFFEkbbCcccggbsskFEEk..........",
   ".........kFEEkbcCCcccggsskEEEk..........",
   ".........kFEEkbCccNnnccgskEEEk..........",
   "..........kEEkbcccnnnccgskEEk...........",
   "...........kk.kccccdccggk.kk............",
   "..............kcgddkddggk...............",
   "..............kRdccgggdqk...............",
   ".............kRRrdddddrqqk..............",
   "............kllbdCCMcddbssk.............",
   "...........kllbCCccmccggbssk............",
   "...........kllbCCcccccggbssk............",
   "...........klbbCCcccccggbssk............",
   "...........klbbbCccccggbsssk............",
   "...........klbbbbccccggbsssk............",
   "..........kbllbbbbcccggbbsssk.....kkk...",
   ".........kbbslllbbccgggbssdFsk...khlbk..",
   ".........kbbslllbdcgggdbssdFsk...klbck..",
   "........klbbdlllbdggggdbssdsFsk.klbcck..",
   "........kbbbdlllbdssEsdbssdsFFk.kbbckk..",
   "........kbbbdllbdEEEEEdbssdsFFkkbsck....",
   "........kbbsdllbdEEEEEdbssdsFFksskk.....",
   "........kbbsdllbddEEEdkbssdsFFkkk.......",
   "........kbsskllbkdddddksbsksFFk.........",
   "........kbsskllbkkkkkkksbsksFEk.........",
   "........kbsskllbk.....kbssksFEk.........",
   "........kbsskllbk.....kbssksFEk.........",
   "........kbdskllck.....kbcsksdEk.........",
   "........kbsklccbk.....kbccsksEk.........",
   "........kkkkcdcdk.....kcdcgkkkk.........",
   "...........kkkkkk.....kkkkkk............",
   "........................................"
  ],
  "sit_happy_0": [
   "........................................",
   "........................................",
   "........................................",
   "................kkkkkkk.................",
   "..............kkhlllbbbkk...............",
   "...........kkkhlllbbbbssskkk............",
   "..........kFldllbsslssbssdFEk...........",
   ".........kFFsklkkllbbbkkskFFEk..........",
   ".........kFFEkdbdlcbbsdbdkFEEk..........",
   ".........kFFEkbbCcccggbsskFEEk..........",
   ".........kFEEkbcCCcccggsskEEEk..........",
   ".........kFEEkbCccNnnccgskEEEk..........",
   "..........kEEkbcccnnnccgskEEk...........",
   "...........kk.kccccdccggk.kk............",
   "..............kcgkptpkggk...............",
   "..............kRdktttpkqk...............",
   ".............kRRrdkkkdrqqk..............",
   "............kllbdCCMcddbssk.............",
   "...........kllbCCccmccggbssk............",
   "...........kllbCCcccccggbssk............",
   "...........klbbCCcccccggbssk............",
   "...........klbbbCccccggbsssk............",
   "...........klbbbbccccggbsssk............",
   "..........kbllbbbbcccggbbsssk...........",
   ".........kbbslllbbccgggbssdFsk..........",
   ".........kbbslllbdcgggdbssdFsk..........",
   "........klbbdlllbdggggdbssdsFsk.........",
   "........kbbbdlllbdssEsdbssdsFFk.........",
   "........kbbbdllbdEEEEEdbssdsFFk...kkk...",
   "........kbbsdllbdEEEEEdbssdsFFk..kllbk..",
   "........kbbsdllbddEEEdkbssdsFFk.klbbck..",
   "........kbsskllbkdddddksbsksFFkkbbcckk..",
   "........kbsskllbkkkkkkksbsksFEkbsckk....",
   "........kbsskllbk.....kbssksFEkkkk......",
   "........kbsskllbk.....kbssksFEk.........",
   "........kbdskllck.....kbcsksdEk.........",
   "........kbsklccbk.....kbccsksEk.........",
   "........kkkkcdcdk.....kcdcgkkkk.........",
   "...........kkkkkk.....kkkkkk............",
   "........................................"
  ],
  "sit_happy_1": [
   "........................................",
   "........................................",
   "........................................",
   "................kkkkkkk.................",
   "..............kkhlllbbbkk...............",
   "...........kkkhlllbbbbssskkk............",
   "..........kFldllbsslssbssdFEk...........",
   ".........kFFsklkkllbbbkkskFFEk..........",
   ".........kFFEkdbdlcbbsdbdkFEEk..........",
   ".........kFFEkbbCcccggbsskFEEk..........",
   ".........kFEEkbcCCcccggsskEEEk..........",
   ".........kFEEkbCccNnnccgskEEEk..........",
   "..........kEEkbcccnnnccgskEEk...........",
   "...........kk.kccccdccggk.kk............",
   "..............kcgkptpkggk...............",
   "..............kRdktttpkqk...............",
   ".............kRRrdkkkdrqqk..............",
   "............kllbdCCMcddbssk.............",
   "...........kllbCCccmccggbssk............",
   "...........kllbCCcccccggbssk............",
   "...........klbbCCcccccggbssk............",
   "...........klbbbCccccggbsssk............",
   "...........klbbbbccccggbsssk............",
   "..........kbllbbbbcccggbbsssk.....kkk...",
   ".........kbbslllbbccgggbssdFsk...khlbk..",
   ".........kbbslllbdcgggdbssdFsk...klbck..",
   "........klbbdlllbdggggdbssdsFsk.klbcck..",
   "........kbbbdlllbdssEsdbssdsFFk.kbbckk..",
   "........kbbbdllbdEEEEEdbssdsFFkkbsck....",
   "........kbbsdllbdEEEEEdbssdsFFksskk.....",
   "........kbbsdllbddEEEdkbssdsFFkkk.......",
   "........kbsskllbkdddddksbsksFFk.........",
   "........kbsskllbkkkkkkksbsksFEk.........",
   "........kbsskllbk.....kbssksFEk.........",
   "........kbsskllbk.....kbssksFEk.........",
   "........kbdskllck.....kbcsksdEk.........",
   "........kbsklccbk.....kbccsksEk.........",
   "........kkkkcdcdk.....kcdcgkkkk.........",
   "...........kkkkkk.....kkkkkk............",
   "........................................"
  ],
  "eat": [
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "............kkkkkkk.....................",
   "..........kkhlllbbbkk...................",
   ".......kkkhlllbbbbssskkk................",
   "......kFldllbsslssbssdFEk...............",
   ".....kFFsklsbllbbbsbskFFEk..............",
   ".....kFFEkbkklcbbskkskFEEk..............",
   ".....kFFEkbbCcccggbsskFEEk..............",
   ".....kFEEkbcCCcccggsskEEEk..............",
   ".....kFEEkbCccNnnccgskEEEkk.............",
   "......kEEkbcccnnnccgskEErqk.............",
   ".......kk.kccccdccggkdrrqqbk............",
   "..........kcgkptpkggdCCccgbk............",
   "...........klbddddkdCCcccgbk............",
   "...........klbbbCccccggbsssk............",
   "...........klbbbbccccggbsssk............",
   "..........kbllbbbbcccggbbsssk...........",
   ".........kbbslllbbccgggbssdFsk..........",
   ".........kbbslllbdcgggdbssdFsk..........",
   "........klbbdlllbdggggdbssdsFsk.........",
   "........kbbbdlllbdssEsdbssdsFFk.........",
   "........kbbbdllbdEEEEEdbssdsFFk...kkk...",
   "........kbbsdllbdEEEEEdbssdsFFk..kllbk..",
   "........kbbsdllbddEEEdkbssdsFFk.klbbck..",
   "........kbsskllbkdddddksbsksFFkkbbcckk..",
   "........kbsskllbkkkkkkksbsksFEkbsckk....",
   "........kbsskllbk.....kbssksFEkkkk......",
   "........kbsskllbk.....kbssksFEk.........",
   "........kbdskllck.....kbcsksdEk.........",
   "........kbsklccbk.....kbccsksEk.........",
   "........kkkkcdcdk.....kcdcgkkkk.........",
   "...........kkkkkk.....kkkkkk............",
   "........................................"
  ],
  "lie": [
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "................kkkkkkk.................",
   "..............kkhlllbbbkk...............",
   "...........kkkhlllbbbbssskkk............",
   ".........kkFldllbsslssbssdFEkkkk........",
   "........klkFFsklsbllbbbsbskFFEksk.......",
   "........kbkFFEkbkklcbbskkskFEEkssk......",
   ".......klbkFFEkbbCcccggbsskFEEkbssk.....",
   ".......kbbkFEEkbcCCcccggsskEEEkbsFk.....",
   ".......kbskFEEkbCccNnnccgskEEEksFFk.kkk.",
   ".......kbsdkEEkbcccnnnccgskEEkksFFkkllbk",
   ".......kbbsskkkccccdccggkkssFFkklbbcckk.",
   "........kbbsllkcgddkddggkbssFFkkbbcckk..",
   "........kbsklccbkccgggkbccsksFEkkkkk....",
   "........kkkkcdcdkkkkkkkcdcgkkkkk........",
   "...........kkkkkk.....kkkkkk............",
   "........................................"
  ]
 }
}
